import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { useLang } from "@/i18n";
import { destinations, photos } from "@/data/site";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBanner } from "@/components/site/CtaBanner";
import { SEO } from "@/components/site/SEO";

export default function CosaVedere() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.pages.cosa.seo} description={t.pages.cosa.desc} path="/cosa-vedere" />
      <PageHero image={photos.ragusaIbla} eyebrow={t.pages.cosa.eyebrow} title={t.pages.cosa.title} testid="cosa-hero" />

      <section className="py-16 sm:py-24" data-testid="destinations-list">
        <div className="mx-auto max-w-7xl space-y-16 px-4 sm:px-6 lg:px-8">
          {destinations.map((d, i) => {
            const dest = t.destinations[d.id];
            const flip = i % 2 === 1;
            return (
              <Reveal key={d.id}>
                <article data-testid={`destination-${d.id}`} className={`grid items-center gap-8 lg:grid-cols-2 ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
                  <div className="overflow-hidden rounded-3xl shadow-xl">
                    <img src={d.img} alt={dest.name} loading="lazy" className="h-72 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-96" />
                  </div>
                  <div className={flip ? "lg:pr-8" : "lg:pl-8"}>
                    <span className="inline-flex items-center gap-2 rounded-full bg-sand-deep px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-mare">
                      <Clock size={14} />
                      {d.time === "0" ? t.position.here : `${d.time} ${t.position.min}`}
                    </span>
                    <h2 className="mt-4 font-serif text-3xl font-semibold text-ink sm:text-4xl">{dest.name}</h2>
                    <p className="mt-4 max-w-lg text-base leading-relaxed text-ink-muted sm:text-lg">{dest.d}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
        <div className="mt-16 text-center">
          <Link to="/prenota" data-testid="cosa-booking-cta" className="inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-base font-bold text-sand shadow-xl shadow-terracotta/25 transition-all duration-200 hover:bg-terracotta-dark hover:-translate-y-0.5">
            {t.hero.cta2} <ArrowRight size={18} />
          </Link>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
